// export const BASE_URL = "http://5.182.17.135:85/api";

// export const BASE_URL = "https://staging.bookcloudme.com:6060/api";

export const BASE_URL = "https://bookcloudme.com:9090/api";
